import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LanguagesService } from 'src/app/services/languages.service';
import { Listlang } from 'src/interface/lang';
import { UserService } from '../../user.service';
import { ApiResponse, ProfileRequest } from 'src/interface/profile';
import { UserData } from 'src/interface/user';
import { UniversalStorageService } from '../../../services/universal-storage.service';

@Component({
    selector: 'app-profile-form',
    templateUrl: './profile-form.component.html',
    styleUrls: ['./profile-form.component.scss'],
})
export class ProfileFormComponent implements OnInit {
    profileForm: FormGroup;
    activeLanguages: Listlang[] = [];
    selectedLanguage: string;
    user_email: string;
    success_message: string;
    error_message: string;
    // userData: any;
    userData: UserData;
    imisid: string;

    constructor(
        private router: Router,
        private langService: LanguagesService,
        private userService: UserService,
        private storageService: UniversalStorageService
    ) {
        this.profileForm = new FormGroup({
            f_name: new FormControl('', [Validators.required]),
            l_name: new FormControl('', [Validators.required]),
            u_name: new FormControl('', [Validators.required]),
            head_line: new FormControl('', [Validators.required]),
            description: new FormControl('', [Validators.required]),
        });
        this.getAllLamguage();
    }
    ngOnInit(): void {
        const token = this.storageService.getItem('BEARER_TOKEN');
        // Replace with your token storage mechanism
        if (token) {
            const tokenPayload = this.decodeToken(token);
            this.user_email = tokenPayload.data.email;
            this.imisid = tokenPayload.data.imis_id;
        }
        this.getUserDetails(this.user_email);
    }
    private decodeToken(token: string) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error('Invalid token format');
        }

        const tokenPayload = JSON.parse(atob(tokenParts[1]));
        return tokenPayload;
    }

    onLanguageChange(event) {
        const selectedValue = event.target?.value || ''; // Use empty string as a fallback
        this.selectedLanguage = selectedValue;
    }
    onSubmit() {
        this.success_message = '';
        this.error_message = '';
        if (this.profileForm.valid && this.selectedLanguage) {
            const formData: ProfileRequest = {
                firstName: this.profileForm.get('f_name')?.value || '', // Use '' as a default value
                lastName: this.profileForm.get('l_name')?.value || '',
                headline: this.profileForm.get('head_line')?.value || '',
                description: this.profileForm.get('description')?.value || '',
                language: this.selectedLanguage,
                email: this.user_email,
                imis_id: this.imisid,
                username: this.profileForm.get('u_name')?.value || '',
                // Add more properties as needed
            };

            this.userService.saveProfileData(formData).subscribe({
                next: (response: ApiResponse) => {
                    if (response.status == 200) {
                        this.success_message = response.message;
                    } else {
                        console.error('Error saving data:', response.message);
                        this.error_message = response.message;
                    }
                },
                error: (error) => {
                    console.error('Error saving data:', error);
                },
                complete: () => {
                    // Handle completion if needed
                },
            });
        } else {
            this.error_message = 'Form is not valid or Language is missing';
            // console.log('Form is not valid or Language is missing.');
        }
    }
    getAllLamguage() {
        this.langService.getActiveLang().subscribe((result) => {
            this.activeLanguages = result.data;
            //   const defaultlang = result.data[0]?.country_language_code;
        });
    }

    getUserDetails(email) {
        this.userService.getProfileDetails(email).subscribe((response) => {
            this.userData = response['data'];
            this.selectedLanguage = this.userData.language;
            this.profileForm.patchValue({
                f_name: this.userData.firstname,
                l_name: this.userData.lastname,
                u_name: this.userData.username,
                head_line: this.userData.headline,
                description: this.userData.desption,
                // language: this.userData.language,
            });
        });
    }
}
